import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { LoadingService } from '../../../services/loadingservice.service';

@Component({
    selector: 'app-loadingspinner',
    templateUrl: './loadingspinner.component.html',
    styleUrls: ['./loadingspinner.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingSpinnerComponent {
  constructor(public loadingservice: LoadingService) {}
}
